import UI from "./UI.class";

export default class Navigation {
	static instance: Navigation = new Navigation()

	private ui = UI.instance

	constructor() {
		this.init()
	}

	private init() {
		this.positionPageNav()
		this.handleActiveLinkOnPageLoad()
		this.handleNavigationToggle()
		this.handleActiveLinkOnclick()
		this.hideCurrentPageCustomMarker()
		this.handleDetailsTagLinkState()
		this.handleDetailsStateOnPageLoad()
		this.observeNavHeight()
	}

	/**
	 * @function HELPER
	 * @returns { string }
	 * @description Current page url string
	 */
	private get getCurrentPage(): string {
		return window.location.pathname;
	}

	/**
	 * @function HELPER
	 * @param listItem 
	 * @param classList
	 * @description Adds active state class to list item element 
	 */
	private setActiveLink(listItem: Element, classList: string): void {
		if (listItem.querySelector("a")?.getAttribute("href") === this.getCurrentPage) {
			listItem.classList.add(classList)
			listItem.closest(".navBarListItem") && listItem.closest(".navBarListItem")?.classList.add(classList)
		}
	}

	private positionPageNav() {
		const { header, pageNav } = this.ui

		const resizeObserver = new ResizeObserver((entries) => {
			entries.forEach(entry => {
				const headerHeight = entry.contentRect.height;
				if (pageNav) {
					const pageNavHeight = pageNav.getBoundingClientRect().height;
					pageNav.style.position = `sticky`
					pageNav.style.top = `calc(${headerHeight + pageNavHeight - pageNavHeight + 10}px)`
					pageNav.style.zIndex = `99`
				}
			})
		})
		resizeObserver.observe(header)
	}

	private observeNavHeight() {
		const { navBar, header } = this.ui

		const resizeObserver = new ResizeObserver((entries) => {
			entries.forEach(entry => {
				if (entry.contentRect.height <= 224) {
					// console.log(entry.contentRect.height)
					header.style.position = `sticky`
					// document.body.setAttribute('data-overlay', 'true')
				} else {
					document.body.removeAttribute('data-overlay')
					header.style.position = `relative`
				}
			})
		})

		resizeObserver.observe(navBar)
	}

	private handleActiveLinkOnPageLoad(): void {
		this.ui.navBarListItem.forEach(listItem => {
			this.setActiveLink(listItem, "active");
		})

		this.ui.navBarDropdownListItem.forEach(listItem => {
			this.setActiveLink(listItem, "active")
		})

	}

	private handleDetailsTagLinkState(): void {
		this.ui.detailsList?.forEach(listItem => {
			const hrefLink = listItem.querySelector("a")?.getAttribute("href")

			const detail = document.querySelector('details')
			const details = this.ui.detailsTag?.querySelectorAll('details')

			if (hrefLink === this.getCurrentPage.replace('/', '')) {
				listItem.classList.add("active")
			}

		})
	}

	private handleDetailsStateOnPageLoad(): void {

		this.ui.detailsList.forEach(item => {
			if (item.classList.contains('active')) {
				item.closest('details')?.setAttribute('open', 'true')
			}
		})

	}

	private handleActiveLinkOnclick(): void {
		const dropdownLists = Array.from(document.querySelectorAll('.dropdownList'))

		this.ui.navBarList?.addEventListener("click", (e) => {
			// store the target value in a variable
			const target = e.target as HTMLAnchorElement;

			// get target attribute for current page
			const currentPage = target.getAttribute("href");


			console.log(target.nextElementSibling)

			if (target.nextElementSibling?.hasAttribute("js-dropdown-menu")) {
				target.nextElementSibling?.removeAttribute("js-dropdown-menu")
			} else {
				dropdownLists.forEach(list => {
					list.removeAttribute("js-dropdown-menu")
				})
				// show the navbar menu
				target.nextElementSibling?.setAttribute("js-dropdown-menu", 'true')
			}



			// If link is already active on page load, move on.
			if (target.closest(".navBarListItem")?.classList.contains("active")) return

			// clear the active state if no link is already active on page load
			this.ui.navBarListItem.forEach(listItem => listItem.classList.remove("active"));
			this.ui.navBarDropdownListItem.forEach(listItem => listItem.classList.remove("active"));

			// check the parent element of target value and add active state to the parent when clicked
			// TODO: check if target href attribute matches current page url
			if (target.closest(".navBarListItem") && currentPage === this.getCurrentPage) {
				target.closest(".navBarListItem")?.classList.add("active")
			}

			if (target.closest(".dropdownListItem") && currentPage === this.getCurrentPage) {
				target.closest(".dropdownListItem")?.classList.add("active")
			}
		})
	}

	private handleNavigationToggle(): void {
		if (this.ui.navBar) {
			const dropdownLists = Array.from(document.querySelectorAll('.dropdownList'))
			this.ui.navBarToggleButton?.addEventListener("click", (e) => {
				this.ui.navBar?.toggleAttribute("js-menu-open")
				this.ui.navBar?.setAttribute("aria-expanded", "")
				document.body.toggleAttribute('data-overlay')
				dropdownLists.forEach(list => {
					list.removeAttribute("js-dropdown-menu")
				})

				if (this.ui.navBar?.hasAttribute("js-menu-open")) {
					this.ui.navBar.setAttribute("aria-expanded", "true")
					this.ui.navBarToggleButton?.setAttribute("aria-expanded", "true")
					// this.ui.body.style.overflowY = "hidden"
				} else {
					this.ui.navBar?.setAttribute("aria-expanded", "false")
					this.ui.navBarToggleButton?.setAttribute("aria-expanded", "false")
					// this.ui.body.removeAttribute('style');
				}
			})
		}

		if (this.ui.pageNavMenu) {
			this.ui.pageNav?.addEventListener("click", () => {
				this.ui.pageNavMenu?.toggleAttribute("js-menu-open")
				this.ui.pageNavMenu?.setAttribute("aria-expanded", "")

				if (this.ui.pageNavMenu?.hasAttribute("js-menu-open")) {
					this.ui.pageNavMenu.setAttribute("aria-expanded", "true")
					this.ui.pageNavToggleButton?.setAttribute("aria-expanded", "true")
					// this.ui.pageNav.style.backgroundColor = "#ffffff"
					// document.body.style.overflow = "hidden"
				} else {
					this.ui.pageNavMenu?.setAttribute("aria-expanded", "false")
					this.ui.pageNavToggleButton?.setAttribute("aria-expanded", "false")
					document.body.removeAttribute('style')
					// this.ui.pageNav.style.backgroundColor = "inherit"
					// document.body.style.overflowX = "hidden"
				}

			})
		}

	}


	/**
	 * @description Function hides custom marker for the link on current page
	 */
	private hideCurrentPageCustomMarker(): void {
		for (const ui of this.ui.customMarker) {
			const lists = ui?.querySelectorAll("li")
			for (const list of lists) {
				const link = list.querySelector("a")
				const href = link?.getAttribute("href");

				if (href === this.getCurrentPage) {
					link?.classList.add("current")
				}

			}

		}
	}
}
